import { render, staticRenderFns } from "./MinhaSolicitacao.vue?vue&type=template&id=afaf743e"
import script from "./MinhaSolicitacao.vue?vue&type=script&lang=js"
export * from "./MinhaSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports